import { render, staticRenderFns } from "./m-dialog-confirmation.vue?vue&type=template&id=a4992af2&scoped=true&lang=pug"
import script from "./m-dialog-confirmation.vue?vue&type=script&lang=js"
export * from "./m-dialog-confirmation.vue?vue&type=script&lang=js"
import style0 from "./m-dialog-confirmation.vue?vue&type=style&index=0&id=a4992af2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4992af2",
  null
  
)

export default component.exports